import { Injectable } from '@angular/core';
import { MatDrawerToggleResult, MatSidenav } from '@angular/material/sidenav';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidenavService {
  private toggleEmitter = new Subject<void>();
  toggle$ = this.toggleEmitter.asObservable();
  private sidenav: MatSidenav;

  close(): Promise<MatDrawerToggleResult> {
    return this.sidenav.close();
  }

  open(): Promise<MatDrawerToggleResult> {
    return this.sidenav.open();
  }

  setSidenav(sidenav: MatSidenav): void {
    this.sidenav = sidenav;
  }

  toggle(): void {
    this.sidenav.toggle();
    this.toggleEmitter.next();
  }
}
